import { FLAGS } from 'affiny-core/helpers/featureToggle';
import { IURLContext } from 'affiny-core/services/config/parser';
import { EHostLang, TEnv } from 'affiny-core/types/env.types';
import { deepMerge } from 'affiny-core/helpers/deepMerge';
import { getKubePreprodConfig } from './kube-preprod';
import { LocalConfig } from './local';
import { getProdConfig } from './prod';
import { getDefaultNationalityIds } from './shared-config';
import { EEnvCountry } from 'affiny-core/env.types';

export const getConfig = ({
  brand,
  envName,
  hostLang,
  country,
}: IURLContext): TEnv => {
  const defaultConfig = {
    featureToggling: {
      [FLAGS.HOME_MESSAGE]: true,
      [FLAGS.LOGIN_DEBUG]: true,
      [FLAGS.LOGIN_FROM_QUERY_PARAMS_DEBUG]: true,
      [FLAGS.PHOTO_REVEAL_SEE_MORE_BUTTON]: true,
      [FLAGS.FLOATING_HOME]: false,
      [FLAGS.LEGAL_60_DAYS]:
        (country === EEnvCountry.FR && hostLang === EHostLang.FR) ||
        (country === EEnvCountry.EN && hostLang === EHostLang.UK),
    },
    publicBasePath: '',
    cookies: {
      domains: [],
    },
    defaultNationalityIds: getDefaultNationalityIds(brand, hostLang),
  };

  return deepMerge(
    defaultConfig,
    getEnvConfig({ brand, envName, hostLang, country })
  );
};

export const getEnvConfig = ({ brand, envName, hostLang, country }): TEnv => {
  switch (envName) {
    case 'local':
      return LocalConfig;
    case 'kuberecette':
      return {
        ...getKubePreprodConfig(brand, hostLang),
        meeticApi: {
          baseApiHostname: `//${window.location.host}`,
          websocketUrl: 'ws://.messaging.',
        },
      };
    case 'preprod':
      return {
        ...getKubePreprodConfig(brand, hostLang),
      };
    case 'prod':
      return getProdConfig(brand, hostLang, country);
    default:
      return getProdConfig(brand, hostLang, country);
  }
};
